export const categories = [
  {
    slug: 'remen-tuijian',
    name: '热门推荐',
    description: '精选最受欢迎的热门视频内容，每日更新推荐榜单',
    icon: 'ri-fire-line',
    color: 'primary',
    count: 1280,
    tags: ['热门', '精选', '每日更新'],
  },
  {
    slug: 'zongyi-yule',
    name: '综艺娱乐',
    description: '最新综艺节目、娱乐八卦、明星动态一网打尽',
    icon: 'ri-emotion-happy-line',
    color: 'accent',
    count: 960,
    tags: ['综艺', '娱乐', '明星'],
  },
  {
    slug: 'dianying-juchang',
    name: '电影剧场',
    description: '高清电影大片、经典影片回顾，影院级视听享受',
    icon: 'ri-film-line',
    color: 'secondary',
    count: 850,
    tags: ['电影', '大片', '高清'],
  },
  {
    slug: 'dianshiju',
    name: '电视剧集',
    description: '热门电视剧、网剧连载，追剧不等待',
    icon: 'ri-tv-line',
    color: 'primary',
    count: 1120,
    tags: ['电视剧', '网剧', '连载'],
  },
  {
    slug: 'dongman-fanju',
    name: '动漫番剧',
    description: '日本动漫、国产动画，二次元爱好者聚集地',
    icon: 'ri-ghost-line',
    color: 'accent',
    count: 760,
    tags: ['动漫', '番剧', '二次元'],
  },
  {
    slug: 'tiyu-saishi',
    name: '体育赛事',
    description: '足球、篮球、电竞等精彩赛事直播与回放',
    icon: 'ri-football-line',
    color: 'secondary',
    count: 540,
    tags: ['体育', '赛事', '直播'],
  },
  {
    slug: 'jilupian',
    name: '纪录纪实',
    description: '自然、历史、科技纪录片，探索世界奥秘',
    icon: 'ri-earth-line',
    color: 'primary',
    count: 420,
    tags: ['纪录片', '自然', '历史'],
  },
  {
    slug: 'duan-shipin',
    name: '短视频精选',
    description: '精彩短视频合集，轻松一刻，欢乐不断',
    icon: 'ri-vidicon-line',
    color: 'accent',
    count: 2100,
    tags: ['短视频', '搞笑', '创意'],
  },
  {
    slug: 'yinyue-MV',
    name: '音乐MV',
    description: '最新音乐MV、演唱会现场，视听双重盛宴',
    icon: 'ri-music-line',
    color: 'secondary',
    count: 680,
    tags: ['音乐', 'MV', '演唱会'],
  },
  {
    slug: 'jiaoyu-xuexi',
    name: '教育学习',
    description: '在线课程、知识科普、技能提升视频资源',
    icon: 'ri-book-open-line',
    color: 'primary',
    count: 350,
    tags: ['教育', '学习', '课程'],
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};